import React from 'react';
import { Users } from 'lucide-react';

function EmptyState({ styles, fonts, t, loading }) {
    if (loading) {
        return (
            <div style={styles.emptyState}>
                <div style={{ fontSize: fonts.subtitle }}>{t.loading}</div>
            </div>
        );
    }

    return (
        <div style={styles.emptyState}>
            <Users size={64} style={{ opacity: 0.3, marginBottom: "1rem" }} />
            <div style={{ fontSize: fonts.subtitle, fontWeight: "600" }}>
                {t.noGroups}
            </div>
            <div style={{ fontSize: fonts.body, marginTop: "0.5rem" }}>
                {t.loadGroups}
            </div>
        </div>
    );
}

export default EmptyState;